import React from "react";
import {useTranslation} from "react-i18next";
import {Heading} from "../../../common/heading";
import {PromoSection} from "../../../common/promo_section";
import {graphql, useStaticQuery} from "gatsby";
import GatsbyImage from "gatsby-image";

export const Introduction: React.FC = () => {
  const {t} = useTranslation();

  const data = useStaticQuery(graphql`
  query {
  promo: file(relativePath: {eq: "promo/Hyperion-Office-promo.jpg"}) { ...promoImage } 
  }`)

  return (
    <PromoSection>
      <div className="page-promo-text">
        <Heading level={1}>{t('products.hyperion.office.introduction.heading')}</Heading>
        <p>{t('products.hyperion.office.introduction.description')}</p>
        <a className="button" href={`/Brochure-Hyperion-Office.pdf`}>{t('products.hyperion.office.introduction.button')}</a>
      </div>
      <div className="page-promo-image">
        <div className="image-holder">
          <div className="image">
            <GatsbyImage
              style={{height: "100%", width: "100%"}}
              fluid={data.promo.childImageSharp.fluid}
            />
          </div>
        </div>
      </div>
    </PromoSection>
  )
}
